import Vue from "vue";
import Router from "vue-router";

// 랜딩페이지
import ViewPc from "@/page/PcView";
// import ViewMobile from "@/page/MobileView";

// 솔닥
import PcContainer from "@/page/PcContainer";
// import MobileContainer from "@/page/MobileContainer";

// 파트너스
import PcPartners from "@/page/PcPartners";
// import MobilePartners from "@/page/MobilePartners";

// 바로돌봄 구버전
// import PcBarocare from "@/page/PcBarocare";
// import MobileBarocare from "@/page/MobileBarocare";

// 바로돌봄 New [2024.05.16]
import PcBarocareNew from "@/page/PcBarocareNew";
// import MobileBarocareNew from "@/page/MobileBarocareNew";

// 바로돌봄 B2C [2024.07.08]
import PcbarocareB2c from "@/page/Pcbarocareb2c";
// import MobileBarocareB2c from "@/page/Mobilebarocareb2c";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        { path: "/", name: "Home", component: PcContainer },
        {
            path: "/view",
            name: "view",
            component: ViewPc,
        },
        {
            path: "/partners",
            name: "partners",
            component: PcPartners,
        },
        {
            path: "/barocare",
            name: "barocare",
            component: PcBarocareNew,
        },
        {
            path: "/barocareb2c",
            name: "barocareb2c",
            component: PcbarocareB2c,
        },

        // { path: "/", name: "Home", component: MobileContainer },
        // {
        //     path: "/view",
        //     name: "view",
        //     component: ViewMobile,
        // },
        // {
        //     path: "/partners",
        //     name: "partners",
        //     component: MobilePartners,
        // },
        // {
        //     path: "/barocare",
        //     name: "barocare",
        //     component: MobileBarocareNew,
        // },
        // {
        //     path: "/barocareb2c",
        //     name: "barocareb2c",
        //     component: MobileBarocareB2c,
        // },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js